import LightBoxImage from './LightBoxImage';

export default LightBoxImage;
